import React from 'react'
import { StateUseContext } from '../../context/UserDetailContext';

const ReferalTable = () => {
    const {referalDataList,referalDetailLoader} = StateUseContext();
  return (
    <div className="table-responsive table_referal">
        <table className='table table-striped verticle-middle text-start'>
            <thead  className="table-primary">
                <tr>
                    <th>S.NO</th>
                    <th>Student Name</th>
                    <th>Student Email</th>
                    <th>Mobile Number</th>
                    <th>Country</th>
                    <th>Class</th>
                    <th>School Name</th>
                    <th>Status</th>
                </tr>
            </thead>
            {
            referalDetailLoader ? 
            <tbody>
                <tr>
                    <td className='text-center py-3' colSpan={8}>
                    <div className="spinner-grow spinner-grow-sm mt-2" role="status">
                            <span  className='visually-hidden'>Loading...</span> 
                    </div> <span className='d-block fw-bold mt-1 ms-2'>Loading data...</span> </td>
                </tr>
            </tbody>
            :
            <tbody>
                {referalDataList.length > 0 ? referalDataList?.map((item,index) => (
                     <tr key={index}>
                     <td>{index+1}</td>
                     <td>{item?.student_name}</td>
                     <td>{item?.student_email}</td>
                     <td>{item?.phone_number}</td>
                     <td>{item?.country_name}</td>
                     <td>{item?.class_name}</td>
                     <td>{item?.school}</td>
                     <td>{item?.status ===1?"Enrolled":"Not Enrolled"}</td>
                 </tr>
                ))
                :<tr><td colSpan={8} className='text-center py-2'>DATA NOT FOUND</td></tr>}
            </tbody>
            }

        </table>
    </div>
  )
}

export default ReferalTable